// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3575":"ce044c50","4935":"08d55499","6080":"81934dee","6782":"81934dee","7425":"81934dee","9869":"81934dee"}[chunkId] + ".chunk.css";
};